"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.existingLoginReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var ExistingLoginAction_1 = require("@/pages/search/actions/sfilter/ExistingLoginAction");
var ExistingLoginState_init_1 = require("@/pages/search/states/ExistingLoginState.init");
exports.existingLoginReducer = function (state, action) {
    if (state === void 0) { state = ExistingLoginState_init_1.defaultExistingLoginState; }
    switch (action.type) {
        case typesafe_actions_1.getType(ExistingLoginAction_1.default.hide): {
            return __assign(__assign({}, state), { isActive: false });
        }
        case typesafe_actions_1.getType(ExistingLoginAction_1.default.show): {
            return __assign(__assign({}, state), { isActive: true });
        }
        case typesafe_actions_1.getType(ExistingLoginAction_1.default.setEmail): {
            return __assign(__assign({}, state), { email: action.payload });
        }
        case typesafe_actions_1.getType(ExistingLoginAction_1.default.setLoginProvider): {
            return __assign(__assign({}, state), { loginProvider: action.payload });
        }
    }
    return state;
};
